import React from 'react';
import PropTypes from 'prop-types';

const Page = ({ body }) => (
  <article
    dangerouslySetInnerHTML={{
      __html: body,
    }}
  />
);

Page.propTypes = {
  body: PropTypes.string.isRequired,
};

export default Page;
